/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { Pageable } from '../model/pageable';
// @ts-ignore
import { PagedModelTipoPraticaRegolaPunteggioFasciaDTO } from '../model/paged-model-tipo-pratica-regola-punteggio-fascia-dto';
// @ts-ignore
import { TipoPraticaRegolaPunteggioFasciaCreationForm } from '../model/tipo-pratica-regola-punteggio-fascia-creation-form';
// @ts-ignore
import { TipoPraticaRegolaPunteggioFasciaDTO } from '../model/tipo-pratica-regola-punteggio-fascia-dto';
// @ts-ignore
import { TipoPraticaRegolaPunteggioFasciaPatchForm } from '../model/tipo-pratica-regola-punteggio-fascia-patch-form';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    TipoPraticaRegolaPunteggioFasciaControllerServiceInterface,
    CreateTipoPraticaRegolaPunteggioFasciaRequestParams,
    DeleteTipoPraticaRegolaPunteggioFasciaRequestParams,
    GetTipoPraticaRegolaPunteggioFasciaRequestParams,
    ListTipoPraticaRegolaPunteggioFasceRequestParams,
    UpdateTipoPraticaRegolaPunteggioFasciaRequestParams
} from './tipo-pratica-regola-punteggio-fascia-controller.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class TipoPraticaRegolaPunteggioFasciaControllerService extends BaseService implements TipoPraticaRegolaPunteggioFasciaControllerServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Crea una nuova fascia della regola A_FASCE
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole/{idRegola}/fasce
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public createTipoPraticaRegolaPunteggioFascia(requestParameters: CreateTipoPraticaRegolaPunteggioFasciaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TipoPraticaRegolaPunteggioFasciaDTO>;
    public createTipoPraticaRegolaPunteggioFascia(requestParameters: CreateTipoPraticaRegolaPunteggioFasciaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TipoPraticaRegolaPunteggioFasciaDTO>>;
    public createTipoPraticaRegolaPunteggioFascia(requestParameters: CreateTipoPraticaRegolaPunteggioFasciaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TipoPraticaRegolaPunteggioFasciaDTO>>;
    public createTipoPraticaRegolaPunteggioFascia(requestParameters: CreateTipoPraticaRegolaPunteggioFasciaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling createTipoPraticaRegolaPunteggioFascia.');
        }
        const idCategoria = requestParameters?.idCategoria;
        if (idCategoria === null || idCategoria === undefined) {
            throw new Error('Required parameter idCategoria was null or undefined when calling createTipoPraticaRegolaPunteggioFascia.');
        }
        const idRegola = requestParameters?.idRegola;
        if (idRegola === null || idRegola === undefined) {
            throw new Error('Required parameter idRegola was null or undefined when calling createTipoPraticaRegolaPunteggioFascia.');
        }
        const tipoPraticaRegolaPunteggioFasciaCreationForm = requestParameters?.tipoPraticaRegolaPunteggioFasciaCreationForm;
        if (tipoPraticaRegolaPunteggioFasciaCreationForm === null || tipoPraticaRegolaPunteggioFasciaCreationForm === undefined) {
            throw new Error('Required parameter tipoPraticaRegolaPunteggioFasciaCreationForm was null or undefined when calling createTipoPraticaRegolaPunteggioFascia.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regola-punteggio-categorie/${this.configuration.encodeParam({name: "idCategoria", value: idCategoria, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regole/${this.configuration.encodeParam({name: "idRegola", value: idRegola, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/fasce`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TipoPraticaRegolaPunteggioFasciaDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: tipoPraticaRegolaPunteggioFasciaCreationForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Elimina una fascia della regola
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole/{idRegola}/fasce/{idFascia}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public deleteTipoPraticaRegolaPunteggioFascia(requestParameters: DeleteTipoPraticaRegolaPunteggioFasciaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteTipoPraticaRegolaPunteggioFascia(requestParameters: DeleteTipoPraticaRegolaPunteggioFasciaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteTipoPraticaRegolaPunteggioFascia(requestParameters: DeleteTipoPraticaRegolaPunteggioFasciaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteTipoPraticaRegolaPunteggioFascia(requestParameters: DeleteTipoPraticaRegolaPunteggioFasciaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling deleteTipoPraticaRegolaPunteggioFascia.');
        }
        const idCategoria = requestParameters?.idCategoria;
        if (idCategoria === null || idCategoria === undefined) {
            throw new Error('Required parameter idCategoria was null or undefined when calling deleteTipoPraticaRegolaPunteggioFascia.');
        }
        const idRegola = requestParameters?.idRegola;
        if (idRegola === null || idRegola === undefined) {
            throw new Error('Required parameter idRegola was null or undefined when calling deleteTipoPraticaRegolaPunteggioFascia.');
        }
        const idFascia = requestParameters?.idFascia;
        if (idFascia === null || idFascia === undefined) {
            throw new Error('Required parameter idFascia was null or undefined when calling deleteTipoPraticaRegolaPunteggioFascia.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regola-punteggio-categorie/${this.configuration.encodeParam({name: "idCategoria", value: idCategoria, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regole/${this.configuration.encodeParam({name: "idRegola", value: idRegola, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/fasce/${this.configuration.encodeParam({name: "idFascia", value: idFascia, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Dettaglio di una fascia della regola
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole/{idRegola}/fasce/{idFascia}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getTipoPraticaRegolaPunteggioFascia(requestParameters: GetTipoPraticaRegolaPunteggioFasciaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TipoPraticaRegolaPunteggioFasciaDTO>;
    public getTipoPraticaRegolaPunteggioFascia(requestParameters: GetTipoPraticaRegolaPunteggioFasciaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TipoPraticaRegolaPunteggioFasciaDTO>>;
    public getTipoPraticaRegolaPunteggioFascia(requestParameters: GetTipoPraticaRegolaPunteggioFasciaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TipoPraticaRegolaPunteggioFasciaDTO>>;
    public getTipoPraticaRegolaPunteggioFascia(requestParameters: GetTipoPraticaRegolaPunteggioFasciaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling getTipoPraticaRegolaPunteggioFascia.');
        }
        const idCategoria = requestParameters?.idCategoria;
        if (idCategoria === null || idCategoria === undefined) {
            throw new Error('Required parameter idCategoria was null or undefined when calling getTipoPraticaRegolaPunteggioFascia.');
        }
        const idRegola = requestParameters?.idRegola;
        if (idRegola === null || idRegola === undefined) {
            throw new Error('Required parameter idRegola was null or undefined when calling getTipoPraticaRegolaPunteggioFascia.');
        }
        const idFascia = requestParameters?.idFascia;
        if (idFascia === null || idFascia === undefined) {
            throw new Error('Required parameter idFascia was null or undefined when calling getTipoPraticaRegolaPunteggioFascia.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regola-punteggio-categorie/${this.configuration.encodeParam({name: "idCategoria", value: idCategoria, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regole/${this.configuration.encodeParam({name: "idRegola", value: idRegola, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/fasce/${this.configuration.encodeParam({name: "idFascia", value: idFascia, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TipoPraticaRegolaPunteggioFasciaDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista paginata delle fasce della regola, ordinate per ordine ASC
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole/{idRegola}/fasce
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listTipoPraticaRegolaPunteggioFasce(requestParameters: ListTipoPraticaRegolaPunteggioFasceRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelTipoPraticaRegolaPunteggioFasciaDTO>;
    public listTipoPraticaRegolaPunteggioFasce(requestParameters: ListTipoPraticaRegolaPunteggioFasceRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelTipoPraticaRegolaPunteggioFasciaDTO>>;
    public listTipoPraticaRegolaPunteggioFasce(requestParameters: ListTipoPraticaRegolaPunteggioFasceRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelTipoPraticaRegolaPunteggioFasciaDTO>>;
    public listTipoPraticaRegolaPunteggioFasce(requestParameters: ListTipoPraticaRegolaPunteggioFasceRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling listTipoPraticaRegolaPunteggioFasce.');
        }
        const idCategoria = requestParameters?.idCategoria;
        if (idCategoria === null || idCategoria === undefined) {
            throw new Error('Required parameter idCategoria was null or undefined when calling listTipoPraticaRegolaPunteggioFasce.');
        }
        const idRegola = requestParameters?.idRegola;
        if (idRegola === null || idRegola === undefined) {
            throw new Error('Required parameter idRegola was null or undefined when calling listTipoPraticaRegolaPunteggioFasce.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling listTipoPraticaRegolaPunteggioFasce.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regola-punteggio-categorie/${this.configuration.encodeParam({name: "idCategoria", value: idCategoria, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regole/${this.configuration.encodeParam({name: "idRegola", value: idRegola, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/fasce`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelTipoPraticaRegolaPunteggioFasciaDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Replace di una fascia della regola (richiede version)
     * @endpoint put /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole/{idRegola}/fasce/{idFascia}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public updateTipoPraticaRegolaPunteggioFascia(requestParameters: UpdateTipoPraticaRegolaPunteggioFasciaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TipoPraticaRegolaPunteggioFasciaDTO>;
    public updateTipoPraticaRegolaPunteggioFascia(requestParameters: UpdateTipoPraticaRegolaPunteggioFasciaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TipoPraticaRegolaPunteggioFasciaDTO>>;
    public updateTipoPraticaRegolaPunteggioFascia(requestParameters: UpdateTipoPraticaRegolaPunteggioFasciaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TipoPraticaRegolaPunteggioFasciaDTO>>;
    public updateTipoPraticaRegolaPunteggioFascia(requestParameters: UpdateTipoPraticaRegolaPunteggioFasciaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling updateTipoPraticaRegolaPunteggioFascia.');
        }
        const idCategoria = requestParameters?.idCategoria;
        if (idCategoria === null || idCategoria === undefined) {
            throw new Error('Required parameter idCategoria was null or undefined when calling updateTipoPraticaRegolaPunteggioFascia.');
        }
        const idRegola = requestParameters?.idRegola;
        if (idRegola === null || idRegola === undefined) {
            throw new Error('Required parameter idRegola was null or undefined when calling updateTipoPraticaRegolaPunteggioFascia.');
        }
        const idFascia = requestParameters?.idFascia;
        if (idFascia === null || idFascia === undefined) {
            throw new Error('Required parameter idFascia was null or undefined when calling updateTipoPraticaRegolaPunteggioFascia.');
        }
        const tipoPraticaRegolaPunteggioFasciaPatchForm = requestParameters?.tipoPraticaRegolaPunteggioFasciaPatchForm;
        if (tipoPraticaRegolaPunteggioFasciaPatchForm === null || tipoPraticaRegolaPunteggioFasciaPatchForm === undefined) {
            throw new Error('Required parameter tipoPraticaRegolaPunteggioFasciaPatchForm was null or undefined when calling updateTipoPraticaRegolaPunteggioFascia.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regola-punteggio-categorie/${this.configuration.encodeParam({name: "idCategoria", value: idCategoria, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regole/${this.configuration.encodeParam({name: "idRegola", value: idRegola, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/fasce/${this.configuration.encodeParam({name: "idFascia", value: idFascia, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TipoPraticaRegolaPunteggioFasciaDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: tipoPraticaRegolaPunteggioFasciaPatchForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
